import { createContext, useCallback, useContext, useMemo, useState } from 'react';

export interface DashboardDynamicBanner {
  icon: React.ElementType;
  message: string;
}

interface DashboardDynamicBannerContextType {
  banner: DashboardDynamicBanner | null;
  showBanner: (banner: DashboardDynamicBanner) => void;
  hideBanner: () => void;
}

export const DashboardDynamicBannerContext = createContext<DashboardDynamicBannerContextType>({
  banner: null,
  showBanner: () => {},
  hideBanner: () => {}
});

export const useDynamicBannerState = () => {
  const [banner, setBanner] = useState<DashboardDynamicBanner | null>(null);

  const showBanner = useCallback((banner: DashboardDynamicBanner) => {
    setBanner(banner);
  }, []);

  const hideBanner = useCallback(() => {
    setBanner(null);
  }, []);

  return useMemo(() => ({ banner, showBanner, hideBanner }), [banner, showBanner, hideBanner]);
};

export const useDynamicBanner = () => {
  return useContext(DashboardDynamicBannerContext);
};
